import React, {ReactElement} from 'react';

import {useEffect} from 'react';
import {pageName} from '../../../lib/constants';
import {setPageName} from '../../../lib/tagmanager';
import {setAppBarTitle, setBackNavEnabled} from '../../../redux/globalSlice';
import {useAppDispatch} from '../../../redux/hooks';
import NegativeFeedback from './NegativeFeedback';

const LMRfeedback = (): ReactElement => {
  useEffect(() => {
    setPageName(pageName.promotionPage);
  }, []);
  useEffect(() => {
    dispatch(setAppBarTitle('Collect your order'));
    dispatch(setBackNavEnabled(true));
    return () => {
      dispatch(setAppBarTitle(''));
      dispatch(setBackNavEnabled(false));
    };
  }, [setAppBarTitle]);
  const dispatch = useAppDispatch();
  return (
    <div className="px-4 py-6 h-full bg-feedback_blue">
      <NegativeFeedback />
    </div>
  );
};

export default LMRfeedback;
